import React, { useState, useEffect } from "react";
import {
    Card,
    Button,
    Input,
    InputNumber,
    Space,
    Row,
    Col,
    message,
    Spin,
} from "antd";

import {
    PlusOutlined,
    SaveOutlined,
    DeleteOutlined,
} from "@ant-design/icons";

import axios from "axios";
import { useConfigQuery } from "../../../../queries/useConfig";

const { TextArea } = Input;

export default function EmbalagensDeProduto({ produto }) {
    const accessToken = window.localStorage.getItem("accessToken");
    const { data: config } = useConfigQuery();

    const [embalagens, setEmbalagens] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // 🔹 FORMATAR QUANTIDADE (BR)
    const formatQuantidadeBR = (value) => {
        if (value === undefined || value === null) return "";
        const [int, dec] = String(value).split(".");
        const intComPontos = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return dec ? `${intComPontos},${dec}` : intComPontos;
    };

    const parseQuantidadeBR = (value) => {
        if (!value) return 0;
        return Number(value.replace(/\./g, "").replace(",", "."));
    };

    // 🔹 CARREGAR EMBALAGENS DA API
    useEffect(() => {
        if (!config?.idLoja || !produto.id) return;

        const load = async () => {
            try {
                const options = {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + accessToken,
                    },
                };

                const url = `https://techspdv-api-d3e739785e34.herokuapp.com/v1/${config.idLoja}/embalagens/produto/${produto.id}`;

                const resp = await axios.get(url, options);

                const embalagensCarregadas = resp.data.map((e) => ({
                    ...e,
                    isNew: false,
                }));

                setEmbalagens(embalagensCarregadas);
            } catch (error) {
                console.error(error);
                message.error("Erro ao carregar embalagens");
            }
        };

        load();
    }, [config?.idLoja, produto.id]);

    // 🔹 Adicionar novo card
    const handleAdd = () => {
        const novo = {
            id: crypto.randomUUID(),
            barras: "",
            descricao: "",
            qtd: "",
            custo: 0,
            preco: 0,
            idProduto: produto.id,
            isNew: true,
        };
        setEmbalagens((prev) => [...prev, novo]);
    };

    // 🔹 Atualizar campo individual
    const updateField = (id, field, value) => {
        setEmbalagens((prev) =>
            prev.map((e) => (e.id === id ? { ...e, [field]: value } : e))
        );
    };

    // 🔹 SALVAR EMBALAGEM
    const handleSave = async (emb) => {
        try {
            const options = {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + accessToken,
                },
            };
            setIsLoading(true);
            const payload = {
                id: emb.id,
                barras: emb.barras,
                descricao: emb.descricao,
                qtd: emb.qtd,
                custo: emb.custo ?? 0,
                preco: emb.preco ?? 0,
                idProduto: produto.id,
            };

            await axios.post(
                `https://techspdv-api-d3e739785e34.herokuapp.com/v1/${config.idLoja}/embalagens`,
                payload,
                options
            );

            message.success("Embalagem salva!");
            updateField(emb.id, "isNew", false);
            setIsLoading(false);
        } catch (err) {
            console.error(err);
            message.error("Erro ao salvar!");
            setIsLoading(false);
        }
    };

    // 🔹 REMOVER EMBALAGEM
    const handleRemove = async (emb) => {
        if (!emb.isNew) {
            try {
                const options = {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + accessToken,
                    },
                };
                setIsLoading(true);
                const url = `https://techspdv-api-d3e739785e34.herokuapp.com/v1/${config.idLoja}/embalagens/${emb.id}`;

                await axios.delete(url, options);

                // 👍 REMOVE SOMENTE SE DELETAR DE VERDADE
                setEmbalagens((prev) => prev.filter((e) => e.id !== emb.id));

                message.success("Embalagem removida!");
                setIsLoading(false);
                return; // evita cair no código abaixo
            } catch (err) {
                console.error(err);
                message.error("Erro ao remover!");
                setIsLoading(false);
                return;
            }
        }

        // Se for nova (não salva), apenas remove da tela
        setEmbalagens((prev) => prev.filter((e) => e.id !== emb.id));
    };

    return (
        <div style={{ padding: 20 }}>
            <h2>Embalagens do Produto</h2>

            {isLoading ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40, width: '100%' }}>
                    <Spin
                        spinning={isLoading}
                        size="large"
                    />
                    {
                        <span style={{ marginTop: 16, fontSize: 14, color: '#666' }}>{'Carregando...'}</span>
                    }
                </div>
            ) :
                (<div> <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={handleAdd}
                    style={{ marginBottom: 20, color:'white', backgroundColor:'black' }}
                >
                    Adicionar Embalagem
                </Button>

                    <Row gutter={[16, 16]}>
                        {embalagens.map((emb) => (
                            <Col xs={24} md={12} lg={12} key={emb.id}>
                                <Card
                                    title="Embalagem"
                                    bordered
                                    style={{ minHeight: 230 }}
                                    extra={
                                        <Space>
                                            <Button
                                                icon={<SaveOutlined />}
                                                type="default"
                                                onClick={() => handleSave(emb)}
                                                style={{ marginBottom: 20, color:'white', backgroundColor:'black' }}
                                            >
                                                Salvar
                                            </Button>
                                            <Button
                                                icon={<DeleteOutlined />}
                                                danger
                                                onClick={() => handleRemove(emb)}
                                                style={{ marginBottom: 20, color:'white', backgroundColor:'red' }}
                                            >
                                                Remover
                                            </Button>
                                        </Space>
                                    }
                                >
                                    <Space direction="vertical" style={{ width: "100%" }} size={12}>

                                        <label><b>Descrição</b></label>
                                        <TextArea
                                            rows={3}
                                            value={emb.descricao}
                                            onChange={(e) =>
                                                updateField(emb.id, "descricao", e.target.value)
                                            }
                                        />

                                        <label><b>Código de Barras</b></label>
                                        <Input
                                            placeholder="Ex: 7891234567890"
                                            value={emb.barras}
                                            onChange={(e) =>
                                                updateField(emb.id, "barras", e.target.value)
                                            }
                                        />

                                        <label><b>Quantidade</b></label>
                                        <InputNumber
                                            style={{ width: "100%" }}
                                            placeholder="Ex: 12,5"
                                            value={emb.qtd}
                                            min={0}
                                            step={0.01}
                                            formatter={formatQuantidadeBR}
                                            parser={parseQuantidadeBR}
                                            onChange={(v) => updateField(emb.id, "qtd", v)}
                                        />
                                    </Space>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
                )
            }
        </div>
    );
}
